export default __webpack_public_path__ + "static/media/cer3.40fe655b.png";